import api_url from "./api_url";


export const speech = async () => {
    try {
        const response = await fetch(`${api_url}/api/speech`);
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: "Failed to fetch posts" };
    }
};
